import { DocumentoDecisaoStatus } from '../../types/documentosValidacao';

const statusComEvidencia: DocumentoDecisaoStatus[] = ['valido', 'valido_com_ressalva'];
const statusComParecer: DocumentoDecisaoStatus[] = [
  'valido_com_ressalva',
  'invalido',
  'incompativel_com_escopo',
  'nao_localizado_no_orgao',
];

export function validateDocumentoDecision(input: {
  status: DocumentoDecisaoStatus;
  evidenciaValidacaoId?: string;
  parecer?: string;
}): string[] {
  const errors: string[] = [];
  if (statusComEvidencia.includes(input.status) && !input.evidenciaValidacaoId) {
    errors.push('Selecione uma evidência para aprovar o documento.');
  }
  if (statusComParecer.includes(input.status) && !input.parecer?.trim()) {
    errors.push('Informe o parecer para a decisão selecionada.');
  }
  return errors;
}
